import { AppConfigModel } from "../abstract/app-config.model";

export class OrganizationActivity extends AppConfigModel {

    static override CLASS_NAME: string = 'OrganizationActivity';
}
